// Single source of truth for IATA pet container rules (mirrors backend/services/iata_rules.py).
export const IATA_SOURCE_URL = 'https://www.iata.org/contentassets/b0016da92c86449f850fe9560827bbea/pet-container-requirements.pdf';
export const IATA_SOURCE_LABEL = 'IATA Pet Container Requirements';

export const IATA_CONTAINER_RULES = {
  en: [
    'Length = A + ½ B (A = nose tip to root of tail; B = floor to elbow joint)',
    'Width = C × 2 (C = width across shoulders or widest point); 2 animals: C × 3; 3 animals: C × 4',
    'Height = D + bedding (D = standing height, top of head or ear tip to floor)',
    'Snub-nosed (brachycephalic) breeds: container 10% larger',
    'Ventilation: at least 16% of the total surface of the four sides, with openings on all four sides',
    'Plastic containers: top and bottom halves bolted together; plastic clips alone are not sufficient; metal bolts recommended in every hole',
  ],
  fr: [
    'Longueur = A + ½ B (A = bout du nez à la base de la queue ; B = sol au coude)',
    'Largeur = C × 2 (C = largeur aux épaules ou au point le plus large) ; 2 animaux : C × 3 ; 3 animaux : C × 4',
    'Hauteur = D + litière (D = hauteur debout, sommet de la tête ou pointe des oreilles)',
    'Races brachycéphales (museau court) : cage 10 % plus grande',
    'Ventilation : au moins 16 % de la surface totale des quatre côtés, avec ouvertures sur les quatre côtés',
    'Cages plastique : moitiés haute et basse boulonnées ; les clips plastique seuls ne suffisent pas ; boulons métal recommandés dans chaque trou',
  ],
};

const WIDTH_MULTIPLIER = { 1: 2, 2: 3, 3: 4 };

export const computeMinDimensions = ({ a, b, c, d, bedding = 0, brachycephalic = false, animals = 1 }) => {
  const f = brachycephalic ? 1.1 : 1;
  const r = (x) => Math.round(x * 10) / 10;
  return {
    length: r((a + b / 2) * f),
    width: r(c * WIDTH_MULTIPLIER[animals] * f),
    height: r((d + bedding) * f),
  };
};

export const IataSourceLink = ({ lang = 'en', className = '' }) => (
  <p className={`text-xs text-slate-500 ${className}`}>
    Source{lang === 'fr' ? ' :' : ':'}{' '}
    <a data-testid="iata-source-link" href={IATA_SOURCE_URL} target="_blank" rel="noopener noreferrer" className="underline hover:text-blue-600">
      {IATA_SOURCE_LABEL}
    </a>
  </p>
);

export const IataRequirementsList = ({ lang = 'en', className = '' }) => (
  <div data-testid="iata-requirements-list" className={className}>
    <ul className="space-y-2 text-slate-700 text-sm">
      {IATA_CONTAINER_RULES[lang === 'fr' ? 'fr' : 'en'].map((rule) => (
        <li key={rule} className="flex gap-2"><span className="text-blue-600">•</span><span>{rule}</span></li>
      ))}
    </ul>
    <IataSourceLink lang={lang} className="mt-3" />
  </div>
);

export const SNUB_NOSED_EXAMPLES = 'pug, French or English bulldog, Boston terrier, boxer, Shih Tzu, Pekingese, Persian, Himalayan, Exotic Shorthair';
export const SNUB_NOSED_SLUGS = ['pug', 'french-bulldog', 'english-bulldog', 'boston-terrier', 'boxer', 'shih-tzu', 'pekingese', 'persian-cat', 'himalayan-cat', 'exotic-shorthair'];
